// src/lib/utils/permission/permissions.js
// ✅ 권한 키(서버/DB와 동일한 문자열이어야 함)
export const PERM = Object.freeze({
  PROJECT_CREATE_FILE_UPLOAD: "project.create_file_upload",
  PROJECT_UPDATE_FILE_UPDATE: "project.update_file_update",
  PROJECT_DELETE_FILE_DELETE: "project.delete_file_delete",
  PROJECT_READ: "project.read",

  REPORT_CREATE: "report.create",
  OBJECT3D_CREATE: "object3d.create",

  NOTICE_WRITE_EDIT: "notice.write_edit",

  USER_REGISTER: "user.register",
  USER_PERMISSION_EDIT: "user.permission_edit",

  ORGANIZATION_CREATE: "organization.create",
  ORGANIZATION_CHILD_CREATE: "organization.child.create",
  ORGANIZATION_DELETE: "organization.delete",
  ORGANIZATION_NOTICE_WRITE: "organization.notice.write",
  ORGANIZATION_USER_MOVE: "organization.user.move",
});
